import { render, staticRenderFns } from "./SelectTopic.vue?vue&type=template&id=2ed80ea5&scoped=true&"
import script from "./SelectTopic.vue?vue&type=script&lang=js&"
export * from "./SelectTopic.vue?vue&type=script&lang=js&"
import style0 from "./SelectTopic.vue?vue&type=style&index=0&id=2ed80ea5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed80ea5",
  null
  
)

export default component.exports